import { render, staticRenderFns } from "./PendenciasView.vue?vue&type=template&id=4d5d3865&scoped=true&"
import script from "./PendenciasView.vue?vue&type=script&lang=ts&"
export * from "./PendenciasView.vue?vue&type=script&lang=ts&"
import style0 from "./PendenciasView.vue?vue&type=style&index=0&id=4d5d3865&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d3865",
  null
  
)

export default component.exports